import LoaderAnimation from 'react-spinners/BeatLoader';
import './Loader.scss'

interface LoaderProps {
    loading: boolean
}

function Loader({ loading }: LoaderProps) {
    return (
        <div className="loader-wrapper" data-testid="loader">
            <LoaderAnimation color={"#00174B"} loading={loading} size={50} />
        </div>
    )
}

export default Loader
